import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProdutoDlgModule } from 'almoxarifado-lib';
import { IMaskModule } from 'angular-imask';
import { PessoaModule, SharedModule } from 'eddydata-lib';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';
import { LicitacaoAudespMenuModule } from '../licitacao-audesp-menu/licitacao-audesp-menu.module';
import { ServicoModule } from '../servico/servico.module';
import { ContratoAditamentoDlgComponent } from './contrato-aditamento-dlg/contrato-aditamento-dlg.component';
import { ContratoAditamentoComponent } from './contrato-aditamento/contrato-aditamento.component';
import { ContratoCompraComponent } from './contrato-compra/contrato-compra.component';
import { ContratoEmpenhoComponent } from './contrato-empenho/contrato-empenho.component';
import { ContratoExtratoRptDlgComponent } from './contrato-extrato-rpt-dlg/contrato-extrato-rpt-dlg.component';
import { ContratoFiscalComponent } from './contrato-fiscal/contrato-fiscal.component';
import { ContratoFormComponent } from './contrato-form/contrato-form.component';
import { ContratoHistoricoDlgComponent } from './contrato-historico-dlg/contrato-historico-dlg.component';
import { ContratoHistoricoComponent } from './contrato-historico/contrato-historico.component';
import { ContratoItemCadComponent } from './contrato-item-cad/contrato-item-cad.component';
import { ContratoItemComponent } from './contrato-item/contrato-item.component';
import { ContratoListComponent } from './contrato-list/contrato-list.component';
import { ContratoOcorrenciaComponent } from './contrato-ocorrencia/contrato-ocorrencia.component';
import { ContratoPagamentoComponent } from './contrato-pagamento/contrato-pagamento.component';
import { ContratoPncpComponent } from './contrato-pncp/contrato-pncp.component';
import { ContratoPppComponent } from './contrato-ppp/contrato-ppp.component';
import { ContratoRcmsComponent } from './contrato-rcms/contrato-rcms.component';
import { ContratoReajusteDlgComponent } from './contrato-reajuste-dlg/contrato-reajuste-dlg.component';
import { ContratoReajusteComponent } from './contrato-reajuste/contrato-reajuste.component';
import { ContratoRecursoRptDlgComponent } from './contrato-recurso-rpt-dlg/contrato-recurso-rpt-dlg.component';
import { ContratoRescisaoDlgComponent } from './contrato-rescisao-dlg/contrato-rescisao-dlg.component';
import { ContratoRescisaoComponent } from './contrato-rescisao/contrato-rescisao.component';
import { ContratoResponsavelComponent } from './contrato-responsavel/contrato-responsavel.component';
import { ContratoRoutingModule } from './contrato-routing.module';
import { ContratoRptComponent } from './contrato-rpt/contrato-rpt.component';
import { ContratoSaldoRptDlgComponet } from './contrato-saldo-rpt-dlg/contrato-saldo-rpt-dlg.component';
import { ContratoStorageComponent } from './contrato-storage/contrato-storage.component';
import { ContratoTerceirizadoComponent } from './contrato-tercerizado/contrato-terceirizado.component';
import { ContratoTestemunhaComponent } from './contrato-testemunha/contrato-testemunha.component';
import { ContratoViewComponent } from './contrato-view/contrato-view.component';
import { ContratoRemanejoComponent } from './contrato-remanejo/contrato-remanejo.component';
import { ContratoRemanejoDlgComponent } from './contrato-remanejo-dlg/contrato-remanejo-dlg.component';
import { FavorecidoDlgModule } from '../favorecido/favorecido-dlg.module';
import { ContratoEnvolvidosPncpComponent } from './contrato-envolvidos-pncp/contrato-envolvidos-pncp.component';
import { ContratoFuncionariosTerceirizadosRptDlgComponent } from './contrato-funcionarios-terceirizados-rpt-dlg/contrato-funcionarios-terceirizados-rpt-dlg.component';

@NgModule({
  declarations: [
    ContratoListComponent,
    ContratoViewComponent,
    ContratoFormComponent,
    ContratoRptComponent,
    ContratoPagamentoComponent,
    ContratoAditamentoComponent,
    ContratoAditamentoDlgComponent,
    ContratoResponsavelComponent,
    ContratoHistoricoComponent,
    ContratoHistoricoDlgComponent,
    ContratoReajusteComponent,
    ContratoReajusteDlgComponent,
    ContratoEmpenhoComponent,
    ContratoCompraComponent,
    ContratoRcmsComponent,
    ContratoStorageComponent,
    ContratoItemComponent,
    ContratoEnvolvidosPncpComponent,
    ContratoItemCadComponent,
    ContratoOcorrenciaComponent,
    ContratoRescisaoComponent,
    ContratoRescisaoDlgComponent,
    ContratoExtratoRptDlgComponent,
    ContratoRecursoRptDlgComponent,
    ContratoFiscalComponent,
    ContratoTestemunhaComponent,
    ContratoPncpComponent,
    ContratoSaldoRptDlgComponet,
    ContratoPppComponent,
    ContratoTerceirizadoComponent,
    ContratoRemanejoComponent,
    ContratoRemanejoDlgComponent,
    ContratoFuncionariosTerceirizadosRptDlgComponent,
  ],
  imports: [
    CommonModule,
    ContratoRoutingModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    InputMaskModule,
    RadioButtonModule,
    SelectButtonModule,
    FileUploadModule,
    PanelModule,
    PessoaModule,
    LicitacaoAudespMenuModule,
    DialogModule,
    ConfirmDialogModule,
    ProdutoDlgModule,
    ServicoModule,
    FieldsetModule,
    CheckboxModule,
    FavorecidoDlgModule,
  ],
  providers: [MessageService, ConfirmationService]
})
export class ContratoModule { }
